import { useCallback, useState } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import Row from "react-bootstrap/Row";

import { Button } from "../../../UI/MUIButton";
import { useNetwork } from "../../../hooks/useNetwork";
import { ReadOnlyWrapper } from "../../../components/ReadOnlyWrapper";
import { TagRemovalModal } from "./components/TagRemovalModal";
import { TagEditModal } from "./components/TagEditModal";
import { TagAddModal } from "./components/TagAddModal";

import { Typography } from "../../../UI/Typography";
import { Grid } from "../../../UI/Grid";

import { useTags } from "./hooks/useTags";
import "./Tags.css";
import { MainLayout } from "../../../layout/MainLayout";
import useAuth from "../../login/AuthContext";

const TagsTable = ({ tags, removeTag, updateTag }) => {
  const [editModalData, setEditModalData] = useState();
  const [removalModalData, setRemovalModalData] = useState();

  const handleSuccessDelete = useCallback((tagId) => {
    setRemovalModalData(null);
    removeTag(tagId);
  }, []);
  const handleSuccessEdit = useCallback((tag) => {
    setEditModalData(null);
    updateTag(tag);
  }, []);

  const columns = [
    {
      dataField: "name",
      text: "Tag",
      formatter: (cell, row) => {
        const onDeleteClick = () => setRemovalModalData(row);
        const onEditClick = () => setEditModalData(row);

        return (
          <Row className="tag-row">
            <Typography className="tag-name">{row.name}</Typography>
            <Row className="tag-name">
              <ReadOnlyWrapper>
                <div className="tag-first-button">
                  <Button size="small" color="error" variant="outlined" onClick={onDeleteClick}>
                    Delete
                  </Button>
                </div>
              </ReadOnlyWrapper>
              <ReadOnlyWrapper>
                <Button size="small" color="primary" variant="outlined" onClick={onEditClick}>
                  Edit
                </Button>
              </ReadOnlyWrapper>
            </Row>
          </Row>
        );
      },
    },
  ];

  return (
    <>
      <TagRemovalModal state={removalModalData} setData={setRemovalModalData} onSuccess={handleSuccessDelete} />
      <TagEditModal state={editModalData} setData={setEditModalData} onSuccess={handleSuccessEdit} />
      <BootstrapTable columns={columns} data={tags} keyField="id" />
    </>
  );
};

export const TagsContainer = () => {
  const { isWriteAccess } = useAuth();
  const { selectedNetwork } = useNetwork();
  const { tags, removeTag, updateTag, addTag } = useTags();
  const [addModalData, setAddModalData] = useState();

  const onAdd = useCallback(() => setAddModalData(true), []);
  const handleSuccessAdd = useCallback((tag) => {
    setAddModalData(null);
    addTag(tag);
  }, []);

  return (
    <MainLayout title="Tags">
      {isWriteAccess() && (
        <>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12}>
              {!!selectedNetwork.l1Id && <TagsTable tags={tags} removeTag={removeTag} updateTag={updateTag} />}
            </Grid>
            <Button variant="contained" color="primary" onClick={onAdd}>
              Add Tag
            </Button>
          </Grid>
          <TagAddModal state={addModalData} setData={setAddModalData} onSuccess={handleSuccessAdd} />
        </>
      )}
    </MainLayout>
  );
};

export const TAGS = "/super-admin/tags";
